import { AppPermission, PermissionKey } from 'shared/types';

export const PERMISSIONS: Record<PermissionKey, AppPermission> = {
  login: 'abg-retail.login',
  'contract.review': 'abg-retail.contract.review',
  'contract.edit': 'abg-retail.contract.edit',
  'customer.view': 'abg-retail.customer.view',
  'customer.request': 'abg-retail.customer.request',
  'customer.approve': 'abg-retail.customer.approve',
  'quoting.view': 'abg-retail.quoting.view',
  'quoting.admin': 'abg-retail.quoting.admin',
  'quoting.review': 'abg-retail.quoting.review',
  'quoting.delete': 'abg-retail.quoting.delete',
  controller: 'abg-retail.controller',
  write: 'fas.abg-retail.write',
  'global.write': 'fas.global.write',
};
